"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var InjectedComponent = /** @class */ (function (_super) {
    __extends(InjectedComponent, _super);
    function InjectedComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            error: undefined
        };
        return _this;
    }
    InjectedComponent.prototype.componentDidCatch = function (error, info) {
        console.error(error, info);
        this.setState({ error: error });
    };
    InjectedComponent.prototype.render = function () {
        var _a = this.props, Component = _a.component, props = __rest(_a, ["component"]);
        if (!this.state.error) {
            return react_1.default.createElement(Component, __assign({}, props));
        }
        return (react_1.default.createElement("div", { className: "panel panel-danger" },
            react_1.default.createElement("div", { className: "panel-heading" }, "Could not display component"),
            react_1.default.createElement("div", { className: "panel-body" },
                react_1.default.createElement("h4", null, "An error occurred while loading the component"),
                react_1.default.createElement("p", null, this.state.error.message)),
            react_1.default.createElement("div", { className: "panel-footer" },
                "Developer? ",
                react_1.default.createElement("a", { href: "https://botpress.com/docs" }, "click here"),
                " to see why this might happen")));
    };
    return InjectedComponent;
}(react_1.Component));
exports.default = InjectedComponent;
